import { Card, CardHeader, CircularProgress, Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { Button, useNotify } from "react-admin";
import { SectionTitle } from "../../../../../src/Components/SectionTitle";
import { Separator } from "../../../../../src/Components/Separator";
import { RequestListGroupType } from "../../../../../src/Enums/RequestListGroupType";
import { RequestStatus } from "../../../../../src/Enums/RequestStatus";
import { useAppDataProvider } from "../../../../dataprovider";
import { useVerifyPermission } from "@airborne/react-admin";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardHeader: {
      padding: 15,
    },
    body: {
      userSelect: "none",
    },
    draggable: {
      marginTop: 15,
      width: "100%",
      textAlign: "center",
      backgroundColor: "#ececec",
    },
    dropzone: {
      overflow: "auto",
      height: 600,
      backgroundColor: theme.palette.background.paper,
      padding: 10,
    },
    toolbar: {
      display: "flex",
      justifyContent: "end",
    },
    backgroundColor: {
      backgroundColor: theme.palette.primary.main,
    },
  })
);

export const RequestStatusGroup = props => {
  useVerifyPermission("customroutes", "requeststatusgroup.read");
  const classes = useStyles();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const [loading, setLoading] = useState<boolean>(false);
  const [timestamp, setTimestamp] = useState<any>(Date.now());
  const [inProgress, setInProgress] = useState<any>([]);
  const [openNotSet, setOpenNotSet] = useState<any>([]);
  const [waitingTTApproval, setWaitingTTApproval] = useState<any>([]);
  const [others, setOthers] = useState<any>([]);
  const [statusGroupList, setStatusGroupList] = useState<any>([]);
  const [createList, setCreateList] = useState<any>([]);
  const [updateList, setUpdateList] = useState<any>([]);
  const [allEnumList, setAllEnumList] = useState<any>([]);
  const [groupNameList, setGroupNameList] = useState<any>([]);
  useEffect(() => {
    document.addEventListener(
      "dragstart",
      function (event: any) {
        event.target.style.opacity = 0.5;
      },
      false
    );
    document.addEventListener(
      "dragend",
      function (event: any) {
        event.target.style.opacity = "";
      },
      false
    );
    document.addEventListener(
      "dragover",
      function (event: any) {
        event.preventDefault();
      },
      false
    );
    document.addEventListener(
      "dragenter",
      function (event: any) {
        if (event.target.className.includes("dropzone")) {
          event.target.style.background = "#ddd";
        }
      },
      false
    );
    document.addEventListener(
      "dragleave",
      function (event: any) {
        if (event.target.className.includes("dropzone")) {
          event.target.style.background = "";
        }
      },
      false
    );
    let enumList: any[] = [];
    for (var enumValue in RequestStatus) {
      if (isNaN(Number(enumValue)) && !RequestListGroupType[enumValue]) {
        var result = enumValue.replace(/([A-Z])/g, " $1");
        var desc = result.charAt(0).toUpperCase() + result.slice(1);
        if (Number(RequestStatus[enumValue]) % 10 == 0) {
          enumList.push({
            Value: Number(RequestStatus[enumValue]),
            Description: desc,
          });
        }
      }
    }
    setAllEnumList(enumList);
  }, []);
  useEffect(() => {
    if (allEnumList.length > 0) {
      loadData();
    }
  }, [allEnumList]);

  const loadData = () => {
    https: dataProvider
      .getRequestStatusGroupList(`pageIndex=0&pageSize=99&sorts=createdDate+DESC`)
      .then((result: any) => {
        const data = result?.data?.items || [];
        setStatusGroupList(data);
        let tempInProgress: any[] = [],
          tempOpenNotSet: any[] = [],
          tempWaitingTTApproval: any[] = [],
          tempOthers: any[] = [];
        for (let index = 0; index < allEnumList.length; index++) {
          const element = allEnumList[index];
          const status = data?.find?.(x => x.requestStatusType === element.Value) || {};
          switch (status.requestStatusGroupType) {
            case RequestListGroupType.OpenNotSet:
              tempOpenNotSet.push({
                ...status,
                description: element.Description,
              });
              break;
            case RequestListGroupType.InProgress:
              tempInProgress.push({
                ...status,
                description: element.Description,
              });
              break;
            case RequestListGroupType.RepairedUnitShipped:
              tempWaitingTTApproval.push({
                ...status,
                description: element.Description,
              });
              break;
            default:
              tempOthers.push({
                ...{},
                requestStatusGroupType: 0,
                requestStatusType: element.Value,
                description: element.Description,
              });
              break;
          }
        }
        setOpenNotSet(tempOpenNotSet);
        setInProgress(tempInProgress);
        setWaitingTTApproval(tempWaitingTTApproval);
        setOthers(tempOthers);
      })
      .catch(error => {
        console.error(error);
      });
    dataProvider
      .getList("requeststatusinfo/reference", {
        pagination: { page: 1, perPage: 5 },
        sort: { field: "id", order: "DESC" },
        filter: {
          [`id = ${RequestStatus.InProgress} || id =  ${RequestStatus.WaitingTTApproval} || id =  ${RequestStatus.OpenNotSet}`]:
            "test",
        },
      })
      .then(response => {
        setGroupNameList(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  };
  const createBulk = () => {
    if (createList.length > 0) {
      setLoading(true);
      dataProvider
        .createBulkRequestStatusGroups(createList)
        .then(result => {
          notify(`Successfully completed`, "success", false, true);
          reset();
        })
        .catch(error => {
          notify(`Error, try again`, "error", false, true);
          setLoading(false);
        });
    }
  };
  const updateBulk = () => {
    if (updateList.length > 0) {
      setLoading(true);
      dataProvider
        .updateBulkRequestStatusGroups(updateList)
        .then(result => {
          notify(`Successfully completed`, "success", false, true);
          reset();
        })
        .catch(error => {
          notify(`Error, try again`, "error", false, true);
          setLoading(false);
        });
    }
  };
  const reset = () => {
    loadData();
    setUpdateList([]);
    setCreateList([]);
    setLoading(false);
    setTimestamp(Date.now());
  };

  const onDropInProgress = event => {
    onDrop(event, RequestListGroupType.InProgress);
  };
  const onDropOpenNotSet = event => {
    onDrop(event, RequestListGroupType.OpenNotSet);
  };
  const onDropWaitingTTApproval = event => {
    onDrop(event, RequestListGroupType.RepairedUnitShipped);
  };
  const onDropOthers = event => {
    onDrop(event, 0);
  };
  const onDrop = (event, groupId: number) => {
    event.preventDefault();
    const statusId = event.dataTransfer.getData("text");
    const status = statusGroupList.find(x => x.requestStatusType === parseInt(statusId));

    if (status) {
      const index = updateList.findIndex(x => x.requestStatusType === parseInt(statusId));
      setUpdateList(oldArray => {
        var newArray = [...oldArray];
        index >= 0
          ? (newArray[index] = {
              ...newArray[index],
              requestStatusGroupType: groupId,
            })
          : newArray.push({ ...status, requestStatusGroupType: groupId });
        return [...newArray];
      });
    } else {
      const index = createList.findIndex(x => x.requestStatusType === parseInt(statusId));
      setCreateList(oldArray => {
        var newArray = [...oldArray];
        if (groupId === 0) {
          return [...newArray.filter(x => x.requestStatusType !== parseInt(statusId))];
        }
        index >= 0
          ? (newArray[index] = {
              ...newArray[index],
              requestStatusGroupType: groupId,
            })
          : newArray.push({
              requestStatusGroupType: groupId,
              requestStatusType: parseInt(statusId),
            });
        return [...newArray];
      });
    }
    event.target.appendChild(document.getElementById(statusId));
    event.target.style.background = "";
    event.dataTransfer.clearData();
  };
  const onDragStart = event => {
    event.dataTransfer.setData("text/plain", `${(event.target as any).id}`);
  };

  const handleSubmit = () => {
    createBulk();
    updateBulk();
  };
  const handleCancel = () => {
    reset();
  };
  const notDrop = event => {
    event.stopPropagation();
  };
  return (
    <Paper key={timestamp} style={{ overflow: "hidden", padding: 25 }}>
      <SectionTitle label="Request Status Group" align="Center" color="Primary" />
      <Separator />

      <Grid container spacing={10} className={classes.body}>
        <Grid item xs={6} md={3}>
          <Card className={classes.dropzone} onDrop={onDropOpenNotSet}>
            <CardHeader
              onDragOver={notDrop}
              className={classes.cardHeader}
              titleTypographyProps={{ color: "primary" }}
              title={
                <strong>
                  {groupNameList != null && groupNameList.length > 0
                    ? groupNameList.filter(condition => condition.id === RequestStatus.OpenNotSet)[0]?.displayName
                    : "OPEN NOT SET"}
                </strong>
              }
            />
            <Divider className={classes.backgroundColor} />
            {openNotSet.map(item => {
              return (
                <ListItem
                  onDragOver={notDrop}
                  id={`${item.requestStatusType}`}
                  key={`${item.requestStatusType}`}
                  className={classes.draggable}
                  draggable="true"
                  onDragStart={onDragStart}
                >
                  <ListItemText primary={`${item.description}`} />
                </ListItem>
              );
            })}
          </Card>
        </Grid>

        <Grid item xs={6} md={3}>
          <Card className={classes.dropzone} onDrop={onDropInProgress}>
            <CardHeader
              onDragOver={notDrop}
              className={classes.cardHeader}
              titleTypographyProps={{ color: "primary" }}
              title={
                <strong>
                  {groupNameList != null && groupNameList.length > 0
                    ? groupNameList.filter(condition => condition.id === RequestStatus.InProgress)[0]?.displayName
                    : "IN PROGRESS"}
                </strong>
              }
            />
            <Divider className={classes.backgroundColor} />
            {inProgress.map(item => {
              return (
                <ListItem
                  onDragOver={notDrop}
                  id={`${item.requestStatusType}`}
                  key={`${item.requestStatusType}`}
                  className={classes.draggable}
                  draggable="true"
                  onDragStart={onDragStart}
                >
                  <ListItemText primary={`${item.description}`} />
                </ListItem>
              );
            })}
          </Card>
        </Grid>

        <Grid item xs={6} md={3}>
          <Card className={classes.dropzone} onDrop={onDropWaitingTTApproval}>
            <CardHeader
              onDragOver={notDrop}
              className={classes.cardHeader}
              titleTypographyProps={{ color: "primary" }}
              title={
                <strong>
                  {groupNameList != null && groupNameList.length > 0
                    ? groupNameList.filter(condition => condition.id === RequestStatus.WaitingTTApproval)[0]
                        ?.displayName
                    : "REPAIRED UNIT SHIPPED"}
                </strong>
              }
            />
            <Divider className={classes.backgroundColor} />
            {waitingTTApproval.map(item => {
              return (
                <ListItem
                  onDragOver={notDrop}
                  id={`${item.requestStatusType}`}
                  key={`${item.requestStatusType}`}
                  className={classes.draggable}
                  draggable="true"
                  onDragStart={onDragStart}
                >
                  <ListItemText primary={`${item.description}`} />
                </ListItem>
              );
            })}
          </Card>
        </Grid>

        <Grid item xs={6} md={3}>
          <Card className={classes.dropzone} onDrop={onDropOthers}>
            <CardHeader
              className={classes.cardHeader}
              titleTypographyProps={{ color: "primary" }}
              title={<strong>{"Out of Choice"}</strong>}
            />
            <Divider className={classes.backgroundColor} />
            {others.map(item => {
              return (
                <ListItem
                  onDragOver={notDrop}
                  id={`${item.requestStatusType}`}
                  key={`${item.requestStatusType}`}
                  className={classes.draggable}
                  draggable="true"
                  onDragStart={onDragStart}
                >
                  <ListItemText primary={`${item.description}`} />
                </ListItem>
              );
            })}
          </Card>
        </Grid>
        <Grid item xs={6}></Grid>
        <Grid item xs={3}>
          <Button
            fullWidth
            label={"Reset"}
            disabled={loading}
            size="medium"
            variant="contained"
            color="primary"
            onClick={handleCancel}
          ></Button>
        </Grid>
        <Grid item xs={3}>
          <Button
            fullWidth
            label={loading ? "Saving!" : "Save"}
            disabled={loading}
            size="medium"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            {loading ? <CircularProgress size="2rem" color="secondary" /> : <></>}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default RequestStatusGroup;
